import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import Swiper from 'swiper'
import fslightbox from 'fslightbox'

import { validate as validateRut } from 'rut.js'

import {
  Navigation as SwiperNavigation,
  Pagination,
  Thumbs,
  FreeMode,
  Autoplay,
} from 'swiper/modules'

import {
  PredictiveSearch,
  SearchForm,
  CartNotification,
  ProductForm,
  CartItems,
  CartRemoveButton,
  CartNote,
  QuantityPopover,
  QuantityInput,
  ProductInfo,
  ProductRecommendations,
  ShowMoreButton,
  VariantSelects,
} from './web-components'
import { CartDrawer, CartDrawerItems } from './web-components/CartDrawer'

//import css swiperjs modules
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/thumbs'
import 'swiper/css/free-mode'
import 'swiper/css/autoplay'

//Alpine plugins
Alpine.plugin(collapse)

//window global variables
window.validateRut = validateRut
//Swiperjs full shopify  declarations
window.SwiperNavigation = SwiperNavigation //remove conflict with global javascript Navigation object
window.Pagination = Pagination
window.Thumbs = Thumbs
window.FreeMode = FreeMode
window.Autoplay = Autoplay
window.Swiper = Swiper

document.addEventListener('DOMContentLoaded', () => {
  // Refrescar fslightbox para detectar nuevos elementos
  refreshFsLightbox()
})

//AlpineJS declarations
window.Alpine = Alpine
Alpine.start()

// Define all web componentes of the site
customElements.define('predictive-search', PredictiveSearch)
customElements.define('search-form', SearchForm)
customElements.define('cart-notification', CartNotification)
customElements.define('cart-remove-button', CartRemoveButton)
customElements.define('cart-items', CartItems)
customElements.define('quantity-input', QuantityInput)
customElements.define('product-recommendations', ProductRecommendations)
customElements.define('variant-selects', VariantSelects)
customElements.define('cart-drawer', CartDrawer)
customElements.define('cart-drawer-items', CartDrawerItems)

//validate if is exist
// product form
if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm)
}

//cart note
if (!customElements.get('cart-note')) {
  customElements.define('cart-note', CartNote)
}
//quantity popover
if (!customElements.get('quantity-popover')) {
  customElements.define('quantity-popover', QuantityPopover)
}

//Product Info
if (!customElements.get('product-info')) {
  customElements.define('product-info', ProductInfo)
}

//Show More button
if (!customElements.get('show-more-button')) {
  customElements.define('show-more-button', ShowMoreButton)
}

// Handle candy rack add to cart - open cart drawer instead of notification
document.addEventListener(
  'ppp-candyrack-button-layout-offers-added-to-cart',
  async (e) => {
    try {
      console.log('candyrack-button-layout-offers-added-to-cart', e)
      // Get cart drawer element
      const cartDrawer = document.querySelector('cart-drawer')
      if (!cartDrawer) return

      // Check if cart was empty before this addition
      const wasEmpty = cartDrawer.classList.contains('is-empty')
      console.log('Cart was empty:', wasEmpty)

      // Get cart data
      const cartResponse = await fetch('/cart.js')
      const cart = await cartResponse.json()

      console.log('CART: ', cart)

      // Get variant ID from the event's product data
      const eventVariantId = e.detail?.product?.variants?.[0]?.id
      console.log('Event variant ID:', eventVariantId)

      // Find the correct item in cart by matching variant ID
      const cartItem = cart.items.find(
        (item) => item.variant_id.toString() === eventVariantId?.toString()
      )

      // If we can't find the item, fallback to last item
      const lastItem = cartItem || cart.items[cart.items.length - 1]
      console.log('Found cart item:', lastItem)

      // Fetch cart drawer sections (same as CartDrawer.getSectionsToRender())
      const sections = {}
      const sectionsToFetch = ['cart-drawer', 'cart-icon-bubble']

      await Promise.all(
        sectionsToFetch.map(async (section) => {
          const response = await fetch(`?section_id=${section}`)
          if (response.ok) {
            const html = await response.text()
            sections[section] = html
          }
        })
      )

      // Create the complete parsedState object
      const parsedState = {
        ...lastItem,
        sections,
      }

      console.log('parsedState', parsedState)

      // Handle empty to non-empty transition
      if (wasEmpty && cart.item_count > 0) {
        console.log('Transitioning from empty to first item')

        // Remove is-empty class from cart drawer
        cartDrawer.classList.remove('is-empty')

        // Remove is-empty class from cart drawer items if it exists
        const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items')
        if (cartDrawerItems) {
          cartDrawerItems.classList.remove('is-empty')
        }
      }

      // Render the cart drawer contents and open it
      cartDrawer.renderContents(parsedState)
    } catch (error) {
      console.error('Error handling candyrack event:', error)
      // Still try to open cart drawer even if update fails
      const cartDrawer = document.querySelector('cart-drawer')
      if (cartDrawer) cartDrawer.open()
    }
  }
)
